/**
 * Types of result response.
 */
export enum Result {
  SUCCESS = 'success',
  ERROR = 'error',
}
/**
 * Tab names for the home page.
 */
export const tabs = {
  latestUpdates: 'latest_updates',
  treatmentOptions: 'treatment_options',
  guidelines: 'guidelines',
  diagnosticTools: 'diagnostic_tools',
  drugs: 'drugs',
  media: 'media',
  latestInnovations: 'latest_innovations',
  labValues: 'lab-values',
  medicalCalculators: 'medical-calculators',
  congresses: 'congresses',
  medicalOpportunities: 'medical_job',
  drugInteractions: 'drug-interactions',
  pocketGuides: 'pocket-guides',
  CME: 'CME', // Continuing Medical Education
};
/**
 * Types for Upload Modal
 */
export enum uploadModalTypes {
  camera = 'camera',
  gallery = 'gallery',
}
export const Speciality = {
  Respiratory: 'Respiratory',
  Cardiology: 'Cardiology',
};
export const Subspeciality = {
  Respiratory: {
    Asthma: 'Asthma',
    COPD: 'COPD',
    Bronchitis: 'Bronchitis',
    Pneumonia: 'Pneumonia',
    CommonCold: 'Common Cold/Flu',
    LungCancer: 'Lung Cancer',
    Pharyngitis: 'Pharyngitis',
    Sinusitis: 'Sinusitis',
    OtitisMedia: 'Otitis Media',
    Tuberculosis: 'Tuberculosis',
  },
  Cardiology: {
    HeartFailure: 'Heart Failure',
    Hypertension: 'Hypertension',
    AtrialFibrillation: 'Atrial Fibrillation',
    CoronaryArteryDisease: 'Coronary artery disease (CAD)',
    Stroke: 'Stroke',
    RheumaticHeartDisease: 'Rheumatic heart disease',
    PulmonaryArterialHypertension: 'Pulmonary Arterial Hypertension',
    MyocardialInfarction: 'Myocardial infarction',
    Atherosclerosis: 'Atherosclerosis',
  },
};

export const TypeOfStudiesAndReaserch = {
  Presentations: 'Presentations',
  Interviews: 'Interviews',
  CaseStudies: 'Case Studies',
  Webinars: 'Webinars',
  MedicalNews: 'Medical News',
};

export const Sensation = {
  Neutral: 'Neutral',
  Positive: 'Positive',
};
export const Resource = {
  MedicalJournals: 'Medical Journals',
  MedicalWebsites: 'Medical Websites',
  ResearchAndMedicalCenters: 'Research and Medical Centers',
};

export enum TabIds {
  LatestUpdates = 1,
  Guidelines = 2,
  TreatmentOptions = 3,
  Congresses = 4,
  Drugs = 5,
  Media = 6,
  DiagnosticTools = 7,
  LatestInnovations = 8,
  MedicalJobOpportunities = 9,
  Diseases = 10,
  LaboratoryValues = 11,
  MedicalCalculators = 12,
  ClinicalCases = 13,
  MedicalReports = 14,
  MonitoringDiseaseProgression = 15,
  FunctionalMedicineSupport = 16,
  PersonalizedGenomicsAnalytics = 17,
  AnomaliesDetection = 18,
  DiseasesPrediction = 19,
  SurvivalAnalysis = 20,
  CompareYourCaseWithSimilar = 21,
  LifeguardsPredictedAlerts = 22,
  EarlyStageAsymptomaticDisease = 23,
  QA = 26,
}

export enum TabKey {
  LatestUpdates = 'latest_updates',
  Guidelines = 'guidelines',
  TreatmentOptions = 'treatment_options',
  Congress = 'congress',
  Drugs = 'drugs',
  Media = 'media',
  DiagnosticTools = 'diagnostic_tools',
  LatestInnovations = 'latest_innovations',
  MedicalJobOpportunities = 'medical_job_opportunities',
  Diseases = 'diseases',
  LaboratoryValues = 'laboratory_values',
  MedicalCalculators = 'medical_calculators',
  ClinicalCases = 'clinical_cases',
  MedicalReports = 'medical_reports',
  MonitoringDiseaseProgression = 'monitoringـdisease_progression',
  FunctionalMedicineSupport = 'functional_medicine_support',
  PersonalizedGenomicsAnalytics = 'personalized_genomics_analytics',
  AnomaliesDetection = 'anomalies_detection',
  DiseasesPrediction = 'diseases_prediction',
  SurvivalAnalysis = 'survival_analysis',
  CompareYourCaseWithSimilar = 'compare_your_case_with_similar ',
  LifeguardsPredictedAlerts = 'lifeguards_predicted_alerts',
  EarlyStageAsymptomaticDisease = 'early_stage_asymptomatic_diseas',
  QA = 'QA',
}

// Create a map to prioritize names for each ID
export const tabIdNameMap: {[key: number]: string} = {
  1: 'LatestUpdates',
  2: 'TreatmentOptions',
  3: 'Guidelines',
  4: 'DiagnosticTools',
  5: 'Media',
  6: 'LatestInnovations',
  7: 'MedicalJobOpportunities',
  8: 'Drugs',
  9: 'Congresses',
};

export enum SpecialityType {
  Cardiology = 1,
  Respiratory = 2,
  Dermatology = 67,
  Endocrinology = 37,
  Neurology = 116,
  Ophthalmology = 133,
  Pediatrics = 94,
  Urology = 83,
  Anti = 192,
  Gastroenterology = 168,
  rheumatology = 148,
}

// Define the enum for action types
export enum ActionType {
  ADD_TO_FAVORITES = 'ADD_TO_FAVORITES',
  REMOVE_FROM_FAVORITES = 'REMOVE_FROM_FAVORITES',
  CREATE_NOTE = 'CREATE_NOTE',
  DELETE_NOTE = 'DELETE_NOTE',
  EDIT_NOTE = 'EDIT_NOTE',
}

// Define the enum for article types
export enum ArticleType {
  SUMMARY = 'SUMMARY',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  NEWS = 'NEWS',
}

export enum LoginFrequency {
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  rarely = 'rarely',
  firstTime = 'first_time',
}

export enum AnalyticsEvents {
  AppOpen = 'APP_OPEN',
  NewsArticleCompleted = 'NEWS_ARTICLE_COMPLETED',
  RecommendationArticleCompleted = 'RECOMMENDATION_ARTICLE_COMPLETED',
  SummaryArticleCompleted = 'SUMMARY_ARTICLE_COMPLETED',
  DrugArticleCompleted = 'DRUG_ARTICLE_COMPLETED',
  NoteActions = 'NOTE_ACTIONS',
  ToggleFavorite = 'TOGGLE_FAVORITE',
  OpenQAndA = 'OPEN_Q_AND_A',
  OpenTab = 'OPEN_TAB',
  OpenSearch = 'OPEN_SEARCH',
  OpenAfterLogin = 'OPEN_AFTER_LOGIN',
}

export enum NewsOptionTab {
  Summaries = 'summaries',
  Analysis = 'analysis',
  Predictions = 'predictions',
}

export enum ScrollDirection {
  None,
  Up,
  Down,
  Left,
  Right,
}

/**
 * Types for deep Linking schema
 */
export enum deepLinkingTypes {
  sharedArticle = 'shared-article',
  sharedChat = 'shared-chat',
  article = 'article',
  empty = '',
}

/**
 * Enum to represent message status states
 */
export enum MessageStatus {
  NotSent, // Message not sent yet (locally)
  SentNotReceived, // Sent but not received by everyone
  ReceivedNotRead, // Received by everyone but not read by everyone
  ReadByEveryone, // Received and read by everyone
}

/**
 * Enum to represent setting key
 */
export enum SettingKey {
  TermsConditions = 'terms_conditions',
  PrivacyPolicyForm = 'privacy_policy_form',
  PrivacyPolicy = 'privacy_policy',
  LaboratoryValues = 'laboratory_values',
  TranslationProvider = 'translation_provider',
  CallUs = 'call_us',
  EmailUs = 'email_us',
  Disclaimer = 'disclaimer',
  DrugsDisclaimer = 'drugs_disclaimer',
  AndroidApplicationVersionNumber = 'android_application_version_number',
  IosApplicationVersionNumber = 'ios_application_version_number',
  DefaultArticleImageUrl = 'default_article_image_url',
}

/**
 * Enum to represent chat type
 */
export enum ChatType {
  QNA = 'QNA',
  ClinicalCase = 'ClinicalCase',
  Drugs = 'QNA',
}

/**
 * Enum to represent chat Event Data type
 */
export enum EventDataType {
  Metadata = 'http.response.metadata',
  Data = 'http.response.body',
  DONE = '[DONE]',
}

/**
 * Types for toast connected-component
 */
export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  HELP = 'help',
}

/**
 * Types of Question Modal.
 */
export const modalTypes = {
  info: 'info',
  question: 'question',
};

/**
 * Types of Fields.
 */
export const FieldType = {
  MULTIPLE_CHOICE: 'multiple_choice',
  SINGLE_CHOICE: 'single_choice',
  MULTILINE_TEXT: 'textarea',
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  BOOLEAN: 'boolean',
  TIME: 'time',
  DATETIME: 'datetime',
};
